import * as React from "react";
const SvgPlaceholder = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	viewBox: "0 0 141.7 144.3",
	width: "1em",
	height: "1em",
	...props
}, /* @__PURE__ */ React.createElement("path", { d: "M141.7 70.9c0 39.2-31.8 70.9-71 70.9-9.5 0-18.9-1.9-27.6-5.6v-25.7c21.8 15.3 52 10 67.3-11.8s10-52-11.8-67.3-52-10-67.3 11.8c-5.4 7.8-8.5 17-8.7 26.5v53C-6.1 96.1-7.7 51.2 19 22.6S90.5-7.7 119.1 19c14.5 13.4 22.6 32.2 22.6 51.9" }), /* @__PURE__ */ React.createElement("path", { d: "M98.6 70.9c0 15.3-12.4 27.7-27.7 27.7S43.2 86.2 43.2 70.9s12.4-27.7 27.7-27.7c15.3-.1 27.7 12.3 27.7 27.7 0-.1 0 0 0 0" }));
export default SvgPlaceholder;
